<template>
  <div v-if="block" class="block">
    <component :is="fieldType" :block="block" />
  </div>
</template>

<script>
import FieldCheckbox from "./fields/Checkbox";
import FieldDate from "./fields/Date";
import FieldRadio from "./fields/Radio";
import FieldSelect from "./fields/Select";
import FieldText from "./fields/Text";
import FieldTextarea from "./fields/Textarea";
import FieldUpload from "./fields/Upload";
import FieldYesNo from "./fields/YesNo";
import FieldGooglemap from "./fields/Googlemap";
import UndefinedField from "./fields/Undefined";
export default {
  components: {
    FieldCheckbox,
    FieldDate,
    FieldRadio,
    FieldSelect,
    FieldText,
    FieldTextarea,
    FieldUpload,
    "field-yesno": FieldYesNo,
    FieldGooglemap,
    UndefinedField
  },
  props: {
    block: {
      type: Object,
      required: true
    }
  },
  computed: {
    fieldType: function() {
      if (this.block && this.block.fieldObject) {
        return "field-" + this.block.fieldObject.type_id;
      } else {
        return "UndefinedField";
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.block {
  display: flex;
}
</style>
